import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARN = 'warn'
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  showToast(type: ToastType, detail: string, duration: number = 5000) {
    console.log('ToastService: showToast');
    console.log('Toast Message:', detail);
    this.messageService.add({
      severity: type,
      summary: this.getSummary(type),
      detail: detail,
      life: duration
    });
  }

  private getSummary(type: ToastType): string {
    switch (type) {
      case ToastType.SUCCESS:
        return 'Success';
      case ToastType.ERROR:
        return 'Error';
      case ToastType.INFO:
        return 'Information';
      case ToastType.WARN:
        return 'Warning';
      default:
        return 'Notification';
    }
  }
}
